module.exports = __webpack_public_path__ + "img/LIMPIA.05cc4d4e.png";